export default __webpack_public_path__ + "static/media/387.c7d0857d.gif";